<template>
  <div>
    <a-row>
      <a-col :span="6">
        {{ title }}
      </a-col>
      <a-col :span="12">
        {{ value }}
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: ["title", "value"],
};
</script>

<style>
</style>
